import { render, staticRenderFns } from "./InvoiceSettingsDialog.vue?vue&type=template&id=2e4c9468"
import script from "./InvoiceSettingsDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSettingsDialog.vue?vue&type=style&index=0&id=2e4c9468&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports